import React from 'react';
import classnames from 'classnames';
import { VisuallyHidden } from '../../../a11y';
import { IconSize } from '../../../Icons/IconWrap';
import s from './Label.networkbar_ui_2.scss';
var Label = function (_a) {
    var isCollapsed = _a.isCollapsed, className = _a.className, children = _a.children, Icon = _a.icon;
    return (React.createElement("div", { className: classnames(s['label'], isCollapsed && s['collapsed-label'], className) },
        Icon && (React.createElement(Icon, { disableDefaultColors: true, size: IconSize.SMALLER, className: s['icon'] })),
        isCollapsed ? React.createElement(VisuallyHidden, null, children) : children));
};
Label.displayName = 'Label';
export default Label;
//# sourceMappingURL=Label.networkbar_ui_2.js.map